// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3NNfx","item":"PaymentsMobile_item__2ayTn","label":"PaymentsMobile_label__3Kp5e","amount":"PaymentsMobile_amount__gGwld"};